(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-capture-health-checkout"] && !Shopify.designMode) return;
  try {
    /**
   * @class
   * @function TdCaptureHealthCheckout
   * Handles cart checkout submissions to Capture Health API
   */
  if (!customElements.get('td-capture-health-checkout')) {
    customElements.define('td-capture-health-checkout', class TdCaptureHealthCheckout extends HTMLElement {
      constructor() {
        super();
        
        // Get elements
        this.submitButton = this.querySelector('.td-capture-health-checkout__button');
        this.errorMessageWrapper = this.querySelector('.td-capture-health-checkout__error-message-wrapper');
        this.errorMessage = this.querySelector('.td-capture-health-checkout__error-message');
        this.apiUrl = this.dataset.apiUrl?.trim();
        this.sectionId = this.dataset.section;
        
        // Initialize button click handler
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
        }
      }
      
      /**
       * Handle button click
       */
      async onSubmitHandler(evt) {
        evt.preventDefault();
        
        // Check if cart is empty
        if (this.submitButton.disabled) {
          return;
        }
        
        // Validate required data
        if (!this.apiUrl) {
          this.showError('Invalid configuration. Please contact support.');
          return;
        }
        
        // Get cart data
        let cartData;
        try {
          const cartResponse = await fetch('/cart.js');
          cartData = await cartResponse.json();
          
          if (!cartData || !cartData.items || cartData.items.length === 0) {
            this.showError('Your cart is empty.');
            return;
          }
        } catch (error) {
          this.showError('Failed to load cart data. Please try again.');
          return;
        }
        
        // Prepare checkout data
        const checkoutData = await this.prepareCheckoutData(cartData);
        
        this.submitCheckout(checkoutData);
      }
      
      /**
       * Prepare checkout data in new format
       */
      async prepareCheckoutData(cartData) {
        const items = [];
        const bundles = [];
        
        // Process cart items by reading data attributes from DOM
        for (const cartItem of cartData.items) {
          // Find the corresponding DOM element
          const cartItemElement = document.querySelector(`#CartDrawer-Item-${cartItem.index + 1}`) || 
                                  document.querySelector(`#CartItem-${cartItem.index + 1}`);
          
          if (!cartItemElement) {
            console.warn('Cart item element not found for item', cartItem.index);
            continue;
          }
          
          const isBundle = cartItemElement.dataset.isBundle === 'true';
          
          if (isBundle) {
            // Handle kit as bundle
            const bundle = this.buildBundle(cartItem, cartItemElement);
            if (bundle) {
              bundles.push(bundle);
            }
          } else {
            // Handle regular item
            const checkoutItem = this.buildItem(cartItem, cartItemElement);
            if (checkoutItem) {
              items.push(checkoutItem);
            }
          }
        }
        
        // Build checkout payload
        const checkoutPayload = {
          items: items,
          bundles: bundles
        };
        
        return checkoutPayload;
      }
      
      /**
       * Build individual item from cart item
       */
      buildItem(cartItem, cartItemElement) {
        // Get offering ID from data attribute
        const offeringId = cartItemElement.dataset.offeringId;
        
        if (!offeringId) {
          console.warn('No offering ID found for cart item', cartItem.handle || cartItem.product_id);
          return null;
        }
        
        // Calculate pricing
        const listPrice = cartItem.original_price / 100;
        const finalPrice = cartItem.final_price / 100;
        const discountAmount = listPrice - finalPrice;
        
        // Get discounts (from cart item discounts)
        const discounts = this.extractDiscounts(cartItem, discountAmount);
        
        return {
          offeringId: offeringId,
          quantity: cartItem.quantity,
          pricing: {
            listPrice: listPrice,
            finalPrice: finalPrice,
            discountAmount: discountAmount > 0 ? discountAmount : undefined
          },
          discounts: discounts.length > 0 ? discounts : undefined
        };
      }
      
      /**
       * Build bundle from kit cart item
       */
      buildBundle(cartItem, cartItemElement) {
        // Get bundle dosage IDs from data attribute
        const bundleDosageIdsJson = cartItemElement.dataset.bundleDosageIds;
        
        if (!bundleDosageIdsJson) {
          console.warn('No bundle dosage IDs found for kit', cartItem.handle || cartItem.product_id);
          return null;
        }
        
        let bundleDosageIds;
        try {
          bundleDosageIds = JSON.parse(bundleDosageIdsJson);
        } catch (error) {
          console.error('Failed to parse bundle dosage IDs', error);
          return null;
        }
        
        if (!Array.isArray(bundleDosageIds) || bundleDosageIds.length === 0) {
          console.warn('Invalid bundle dosage IDs format', bundleDosageIds);
          return null;
        }
        
        // Build bundle items
        const bundleItems = bundleDosageIds.map((dosageId, index) => {
          // Default quantity distribution - you may want to customize this logic
          const quantityPerDosage = Math.floor(cartItem.quantity / bundleDosageIds.length);
          const remainder = cartItem.quantity % bundleDosageIds.length;
          
          return {
            offeringId: dosageId,
            quantity: quantityPerDosage + (index < remainder ? 1 : 0)
          };
        });
        
        // Calculate bundle pricing
        const listPrice = cartItem.original_price / 100;
        const finalPrice = cartItem.final_price / 100;
        
        // Get product title from cart item element or cart data
        const productTitle = cartItemElement.querySelector('.cart-item__name')?.textContent?.trim() || 
                            cartItem.product_title || 
                            'Bundle';
        
        return {
          id: `bundle-${cartItem.product_id}`,
          name: productTitle,
          description: '',
          items: bundleItems,
          pricing: {
            listPrice: listPrice,
            finalPrice: finalPrice
          }
        };
      }
      
      /**
       * Extract discounts from cart item
       */
      extractDiscounts(cartItem, discountAmount) {
        const discounts = [];
        
        // Check for discount codes in cart item discounts
        if (cartItem.discounts && cartItem.discounts.length > 0) {
          cartItem.discounts.forEach(discount => {
            discounts.push({
              type: discount.type || 'percentage',
              code: discount.code || '',
              description: discount.title || '',
              amount: discount.amount || 0,
              appliedAmount: discountAmount || 0
            });
          });
        }
        
        return discounts;
      }
      
      /**
       * Submit checkout to Capture Health API
       */
      async submitCheckout(checkoutData) {
        try {
          this.setLoadingState(true);
          this.hideError();

          const response = await fetch(this.apiUrl, {
            method: 'POST',
            headers: {
              'Origin': `${window.location.origin}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(checkoutData)
          });
          
          const responseData = await response.json();
          
          if (response.ok) {
            // Success - redirect to Capture Health checkout
            if (responseData.redirectUrl || responseData.redirect_url || responseData.url) {
              window.location.href = responseData.redirectUrl || responseData.redirect_url || responseData.url;
            } else {
              this.showError('Checkout URL not provided. Please contact support.');
            }
          } else {
            // API error
            this.showError(`Checkout Error: ${response.status} - ${responseData.message || responseData.error || 'Unknown error'}`);
          }
        } catch (error) {
          console.error('Capture Health checkout error:', error);
          this.showError('Network error occurred. Please check your connection and try again.');
        } finally {
          this.setLoadingState(false);
        }
      }
      
      /**
       * Set loading state on button
       */
        setLoadingState(loading) {
          if (this.submitButton) {
            if (loading) {
              this.submitButton.classList.add('loading');
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButton.disabled = true;
            } else {
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              // Only re-enable if cart is not empty
              const cartFooter = document.querySelector('#main-cart-footer');
              const cartDrawer = document.querySelector('cart-drawer');
              const isCartEmpty = (cartFooter && cartFooter.classList.contains('is-empty')) || 
                                 (cartDrawer && cartDrawer.classList.contains('is-empty'));
              if (!isCartEmpty) {
                this.submitButton.disabled = false;
              }
            }
          }
        }
      
      /**
       * Show error message
       */
      showError(message) {
        if (this.errorMessageWrapper && this.errorMessage) {
          this.errorMessage.textContent = message;
          this.errorMessageWrapper.hidden = false;
          
          // Hide error after 5 seconds
          setTimeout(() => {
            this.hideError();
          }, 5000);
        }
      }
      
      /**
       * Hide error message
       */
      hideError() {
        if (this.errorMessageWrapper) {
          this.errorMessageWrapper.hidden = true;
        }
      }
      
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-kit-upsell-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-kit-upsell-drawer')) {
    class TDKitUpsellDrawer extends HTMLElement {
      constructor() {
        super();
        this.overlay = this.querySelector('.td-kit-upsell-drawer__overlay');
        this.closeButton = this.querySelector('.td-kit-upsell-drawer__close');
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.addToCartButton = this.querySelector('[data-add-to-cart]');

        this.setupEventListeners();
      }

      setupEventListeners() {
        document.addEventListener('open-product-drawer', this.handleOpenProductDrawer.bind(this));
        
        // Close button click
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.close.bind(this));
        }
        
        // Overlay click
        if (this.overlay) {
          this.overlay.addEventListener('click', this.handleOverlayClick.bind(this));
        }
        
        // Prevent clicks inside drawer inner from closing
        this.inner = this.querySelector('.td-kit-upsell-drawer__inner');
        if (this.inner) {
          this.inner.addEventListener('click', (e) => e.stopPropagation());
        }

        // Add to cart button
        if (this.addToCartButton) {
          this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
        }
        
        // Escape key handler
        this.handleKeyDown = this.handleKeyDown.bind(this);
      }

      handleOpenProductDrawer(event) {
        const targetProductId = event.detail.productId;
        if (targetProductId !== this.productId) {
          return;
        }
        
        this.open();
      }
      
      handleOverlayClick(event) {
        // Only close if clicking directly on the overlay, not on child elements
        if (event.target === this.overlay) {
          this.close();
        }
      }

      handleAddToCart(event) {
        if (!this.variantId) {
          console.error('No variant ID available');
          return;
        }

        if (this.addToCartButton.getAttribute('aria-disabled') === 'true') return;

        // Disable button and show loading state
        this.addToCartButton.setAttribute('aria-disabled', 'true');
        this.addToCartButton.classList.add('loading');
        const originalHTML = this.addToCartButton.innerHTML;

        // Prepare form data
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);

        // Get cart drawer/notification if available
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && cart.getSectionsToRender) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) {
            cart.setActiveElement(document.activeElement);
          }
        }

        // Fetch config
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        // Add to cart
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error adding to cart
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'td-kit-upsell-drawer',
                  productVariantId: this.variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              console.error('Error adding to cart:', response.description);
              this.addToCartButton.innerHTML = originalHTML;
              this.addToCartButton.removeAttribute('aria-disabled');
              this.addToCartButton.classList.remove('loading');
              this.error = true;
              return;
            }

            // Success
            this.error = false;

            // If no cart drawer/notification, redirect to cart page
            if (!cart) {
              window.location = routes.cart_url;
              return;
            }

            // Update cart drawer/notification
            if (cart.renderContents) {
              cart.renderContents(response);
            }

            // Publish cart update event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'td-kit-upsell-drawer',
                productVariantId: this.variantId,
                cartData: response,
              });
            }

            // Close drawer after successful add to cart
            setTimeout(() => {
              this.close();
            }, 500);
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            this.addToCartButton.innerHTML = originalHTML;
            this.addToCartButton.removeAttribute('aria-disabled');
            this.addToCartButton.classList.remove('loading');
            this.error = true;
          })
          .finally(() => {
            this.addToCartButton.classList.remove('loading');
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.addToCartButton.removeAttribute('aria-disabled');
            }
          });
      }
      
      open() {
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
        
        // Add escape key listener when drawer opens
        document.addEventListener('keydown', this.handleKeyDown);
        
        // Trap focus
        setTimeout(() => {
          if (typeof trapFocus !== 'undefined') {
            trapFocus(this, this.closeButton);
          }
        }, 100);
      }
      
      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        
        // Remove escape key listener when drawer closes
        document.removeEventListener('keydown', this.handleKeyDown);
        
        if (typeof removeTrapFocus !== 'undefined') {
          removeTrapFocus();
        }
      }
      
      handleKeyDown(event) {
        if (event.code === 'Escape' && this.classList.contains('active')) {
          this.close();
        }
      }
    }
    
    customElements.define('td-kit-upsell-drawer', TDKitUpsellDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-treatment-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-treatment-drawer')) {
  class TreatmentDrawer extends HTMLElement {
    constructor() {
      super();
      this.activeElement = null;
      this.boundHandleTreatmentClick = null;
      this.boundClose = null;
      this.boundHandleKeyup = null;
    }

    connectedCallback() {
      this.sectionId = this.id ? this.id.replace('td-treatment-drawer-', '') : '';
      
      // DOM elements
      this.overlay = this.querySelector('.td-treatment-drawer__overlay');
      this.inner = this.querySelector('.td-treatment-drawer__inner');
      this.closeButton = this.querySelector('.td-treatment-drawer__close');
      this.titleEl = this.querySelector('.td-treatment-drawer__title');
      this.kitsContainer = this.querySelector('.td-treatment-drawer__kits');
      this.weekenderBadge = this.querySelector('.td-treatment-drawer__kit-badge--weekender');
      this.descriptionEl = this.querySelector('.td-treatment-drawer__description');
      this.medicationsContainer = this.querySelector('.td-treatment-drawer__medications');
      this.symptomsHeadingEl = this.querySelector('.td-treatment-drawer__symptoms-heading');
      this.symptomsListEl = this.querySelector('.td-treatment-drawer__symptoms-list');
      this.calloutHeadingEl = this.querySelector('.td-treatment-drawer__callout-heading');
      this.calloutContentEl = this.querySelector('.td-treatment-drawer__callout-content');
      
      this.setupListeners();
    }

    disconnectedCallback() {
      if (this.classList.contains('active')) {
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.activeElement);
        }
      }
      
      this.removeListeners();
    }
    
    setupListeners() {
      this.boundHandleTreatmentClick = this.handleTreatmentClick.bind(this);
      this.boundClose = this.close.bind(this);
      this.boundHandleKeyup = (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      };
      this.boundHandleLinkClick = this.handleLinkClick.bind(this);

      document.addEventListener('treatment-item-click', this.boundHandleTreatmentClick);
      
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.boundClose);
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', this.boundClose);
      }
      this.addEventListener('keyup', this.boundHandleKeyup);
      
      /* Close drawer when clicking links inside the drawer content */
      if (this.inner) {
        this.inner.addEventListener('click', this.boundHandleLinkClick);
      }
    }

    removeListeners() {
      if (this.boundHandleTreatmentClick) {
        document.removeEventListener('treatment-item-click', this.boundHandleTreatmentClick);
      }
      if (this.closeButton && this.boundClose) {
        this.closeButton.removeEventListener('click', this.boundClose);
      }
      if (this.overlay && this.boundClose) {
        this.overlay.removeEventListener('click', this.boundClose);
      }
      if (this.boundHandleKeyup) {
        this.removeEventListener('keyup', this.boundHandleKeyup);
      }
      if (this.inner && this.boundHandleLinkClick) {
        this.inner.removeEventListener('click', this.boundHandleLinkClick);
      }
    }

    /**
     * Handle clicks on links inside the drawer content
     * Closes the drawer when any link is clicked
     */
    handleLinkClick(event) {
      const link = event.target.closest('a');
      if (link) {
        this.close();
      }
    }

    parseJsonAttribute(value) {
      if (!value || value === '' || value === '[]') {
          return value === '[]' ? [] : '';
        }
        if (typeof value === 'string' && (value.trim().startsWith('[') || value.trim().startsWith('{'))) {
          try {
            return JSON.parse(value);
          } catch (e) {
            return value;
          }
        }
      return value;
    }

    handleTreatmentClick(event) {
      const { sectionId, treatmentData } = event.detail;
      
      // Only respond to clicks from this drawer's associated section
      if (sectionId !== this.sectionId) return;
      
      this.populateDrawer(treatmentData);
      this.open();
    }
    
    populateDrawer(data) {
      if (this.titleEl) {
        this.titleEl.textContent = data.title;
      }

      if (this.kitsContainer) {
        this.kitsContainer.innerHTML = '';
        const approvedKits = this.parseJsonAttribute(data.approvedKits);
        const failingKits = this.parseJsonAttribute(data.failingKits);

        if (Array.isArray(approvedKits) && approvedKits.length > 0) {
          approvedKits.forEach(kit => {
            const kitItem = document.createElement('div');
            kitItem.className = 'td-treatment-drawer__kit-badge td-treatment-drawer__kit-badge--treats';
            
            const icon = document.createElement('div');
            icon.className = 'td-treatment-drawer__kit-icon';
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#004422"/><path d="M5.8335 10.4167L8.3335 13.3333L13.3335 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            
            const text = document.createElement('span');
            text.className = 'td-treatment-drawer__kit-text';
            text.textContent = kit;
            
            kitItem.appendChild(icon);
            kitItem.appendChild(text);
            this.kitsContainer.appendChild(kitItem);
          });
        }

        if (Array.isArray(failingKits) && failingKits.length > 0) {
          failingKits.forEach(kit => {
            const kitItem = document.createElement('div');
            kitItem.className = 'td-treatment-drawer__kit-badge td-treatment-drawer__kit-badge--doesnt-treat';
            
            const icon = document.createElement('div');
            icon.className = 'td-treatment-drawer__kit-icon td-treatment-drawer__kit-icon--close';
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 1.2583L6.78151 7" stroke="#969189" stroke-width="2" stroke-linecap="round"/><path d="M1.26904 7L6.51904 1" stroke="#969189" stroke-width="2" stroke-linecap="round"/></svg>';
            
            const text = document.createElement('span');
            text.className = 'td-treatment-drawer__kit-text';
            text.textContent = kit;
            
            kitItem.appendChild(icon);
            kitItem.appendChild(text);
            this.kitsContainer.appendChild(kitItem);
          });
        }
      }

      if (this.descriptionEl) {
        this.descriptionEl.innerHTML = data.description;
      }

      if (this.medicationsContainer) {
        this.medicationsContainer.innerHTML = '';
        const medications = this.parseJsonAttribute(data.medications);

        if (Array.isArray(medications) && medications.length > 0) {
          medications.forEach(medication => {
            const medicationItem = document.createElement('div');
            medicationItem.className = 'td-treatment-drawer__medication-pill';
            medicationItem.textContent = medication;
            this.medicationsContainer.appendChild(medicationItem);
          });
        }
      }

      if (this.symptomsHeadingEl) {
        this.symptomsHeadingEl.textContent = data.heading;
      }
      
      if (this.symptomsListEl) {
        this.symptomsListEl.innerHTML = '';
        const symptoms = this.parseJsonAttribute(data.symptoms);

        if (Array.isArray(symptoms) && symptoms.length > 0) {
          symptoms.forEach(symptom => {
            const symptomItem = document.createElement('div');
            symptomItem.className = 'td-treatment-drawer__symptom-item';
            
            const icon = document.createElement('div');
            icon.className = 'td-treatment-drawer__symptom-icon';
            icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#004422"/><path d="M5.8335 10.4167L8.3335 13.3333L13.3335 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            
            const text = document.createTextNode(symptom);
            
            symptomItem.appendChild(icon);
            symptomItem.appendChild(text);
            this.symptomsListEl.appendChild(symptomItem);
          });
        }
      }
      
      if (this.calloutHeadingEl) {
        this.calloutHeadingEl.textContent = data.calloutHeading;
      }
      
      if (this.calloutContentEl) {
        this.calloutContentEl.innerHTML = data.calloutContent;
      }
    }
    
    /**
     * Open the drawer
     */
    open() {
      this.activeElement = document.activeElement;
      
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');

      const focusElement = this.querySelector('.td-treatment-drawer__close') || this.querySelector('.td-treatment-drawer__inner');
      if (typeof trapFocus === 'function') {
        trapFocus(this.querySelector('.td-treatment-drawer__inner'), focusElement);
      }
    }
    
    /**
     * Close the drawer
     */
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      
      // Remove focus trap and restore focus to triggering element
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }
      
      this.activeElement = null;
    }
  }
  
  customElements.define('td-treatment-drawer', TreatmentDrawer);
}
  } catch(e) { console.error(e); }
})();

})();
